<div>
  <div class="grid mt-2 mx-3 mr-0">
    <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
      <label class="category-name" translate>protocol.lbl_activity_feed</label>
    </div>
  </div>
</div>
<div class="mx-3">
  @if(allColumns?.length > 0) {

    <app-mi-table
      [collectionOfColumns]="allColumns"
      [attributeLabels]="filterAttributeLabels"
      [data]="tableData"
      [isLoading]="isLoading"
      (onPageChange)="onPageChange($event)"
      (itemPerPageChange)="itemPerPageChange($event)"
      (onValueChange)="onFilterValueChange($event)"
      [filterFields]="filterFieldsArray"
      [attributeData]="attributeData"
      [bulkUpdateLabel]="bulkUpdateLabel"
      [bulkUpdateHeader]="bulkUpdateHeader"
      [entityNameToDisplay]="entityNameToDisplay"
      [reviewHeader]="reviewHeader"
      (onSearchValueChange)="onSearchValueChanges($event)"
      [totalRecords]="totalRecords"
      [visible]="visible"
      (onToggleOverLay)="showBulkUpdateDialog = false"
      [isEntity]="isEntity"
      (onSortData)="onSortData($event)"
      entityName="protocol_activity">
    </app-mi-table>
  }

</div>